import { type HttpAdapter, HttpError, type HttpHeader, type HttpMethod } from './http.interface'
import type { URL } from '../@shared/interfaces/value-objects.interface'

export class XmlRequest implements HttpAdapter {
  private headers: HttpHeader = {}
  public useDefaultHeaders: boolean = true

  private readonly defaultHttpHeaders: HttpHeader = {
    'Content-Type': 'application/json'
  }

  getDefaultHeaders (): HttpHeader {
    return this.defaultHttpHeaders
  }

  setHeaders (headers: HttpHeader): void {
    this.headers = headers
  }

  // eslint-disable-next-line @typescript-eslint/promise-function-async
  request<Response, Payload = {}>(method: HttpMethod, url: URL, payload?: Payload): Promise<Response> {
    return new Promise<Response>((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open(method, url)

      if (this.useDefaultHeaders)
        this.headers = { ...this.headers, ...this.defaultHttpHeaders }

      for (const [headerProperty, headerValue] of Object.entries(this.headers))
        xhr.setRequestHeader(headerProperty, headerValue)

      xhr.onload = () => {
        const { status, response } = xhr
        if (status >= 200 && status < 300) resolve(JSON.parse(response) as Response)
        reject(new HttpError({ status, response: JSON.parse(response) }))
      }

      xhr.onerror = () => {
        const { status, response } = xhr
        reject(new HttpError({ status, response: JSON.parse(response) }))
      }

      xhr.send(JSON.stringify(payload))
    })
  }
}
